const Contact = () => {
  return <>This is Contact page</>;
};

export default Contact;
